import { Alert, Button, Group, Loader, Modal, Stack, Text, TextInput } from "@mantine/core";
import { skipToken } from "@reduxjs/toolkit/query";
import { openapi } from "../../openapi";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { setArticleDetailsNumber, setArticleDetailsSearch } from "../DrofusOccurrenceValidation/drofusOccurrenceValidationSlice";
import { selectArticleDetailsArg, selectArticleDetailsView } from "./articleDetailsSelectors";
import { ArticleDetailsFields } from "./ArticleDetailsFields";

export function ArticleDetailsModal() {
  const dispatch = useAppDispatch();
  const arg = useAppSelector(selectArticleDetailsArg);
  const view = useAppSelector(selectArticleDetailsView);
  const { refetch, isFetching } = openapi.usePostFunctionsDrofusArticlesDetailsQuery(arg ?? skipToken, { refetchOnMountOrArgChange: true });
  return <Modal opened={view.opened} onClose={() => dispatch(setArticleDetailsNumber(null))} title={view.title} size="xl" zIndex={310}>
    <Stack>
      <Group justify="space-between">
        <Text size="sm" c="dimmed">{view.fieldCount} felt fra dRofus · Tomme felt vises som –</Text>
        <Button variant="subtle" size="xs" disabled={!arg} loading={isFetching} onClick={() => refetch()}>Oppdater</Button>
      </Group>
      <TextInput placeholder="Søk i feltnavn og verdier..." value={view.search} onChange={event => dispatch(setArticleDetailsSearch(event.currentTarget.value))} />
      {view.loading ? <Loader /> : view.error ? <Alert color="red">Kunne ikke hente artikkeldata fra dRofus. Prøv Oppdater.</Alert>
        : view.notFound ? <Alert>Artikkelen finnes ikke i dRofus.</Alert> : <ArticleDetailsFields />}
    </Stack>
  </Modal>;
}
